function createBloomreachApiUrl(baseUrl, locale) {
  if (locale !== void 0 && !baseUrl.includes(locale.replace("-", "_"))) {
    return `${baseUrl}/${locale.replace("-", "_")}`;
  }
  return baseUrl;
}
export {
  createBloomreachApiUrl
};
//# sourceMappingURL=create-api-url.js.map
